/**
 * Returns whether the filters are active
 * @param {Object} param0 filter parameters
 * @returns {Boolean} at least one filter is enabled
 */
export const areFiltersActive = ({ opcoId, federationId, searchTerm }) => {
    return !!opcoId || !!federationId || !!searchTerm;
}

/**
 * Returns whether there are inactive accounts
 * @param {Array} accounts account list
 * @returns {Boolean} whether at least one account is an inactive one
 */
export const hasInactiveAccounts = accounts => {
    if (!Array.isArray(accounts) || !accounts.length) {
        return false;
    }

    for (const account of accounts) {
        if (!account || !account.isActive) {
            return true;
        }
    }
    return false;
}
